// extracted by mini-css-extract-plugin
module.exports = {"card-width":"FirstStep_card-width__2oXJ6","max-w-icon-text":"FirstStep_max-w-icon-text__2WWNe"};